import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/** Évite l'écran blanc silencieux si un module (ex. @itaas/ports) plante au démarrage. */
export class PepErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("PEP render error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="container py-5" style={{ maxWidth: 640 }}>
        <h1 className="h4 text-danger mb-3">ITaaS PEP — erreur de chargement</h1>
        <p className="text-secondary">
          L&apos;interface n&apos;a pas pu démarrer. En local, exécutez d&apos;abord{" "}
          <code>pnpm ports:sync</code> à la racine du produit, puis relancez{" "}
          <code>pnpm dev:web</code> et <code>pnpm dev:api</code>.
        </p>
        <pre className="small bg-light border rounded p-3 text-danger mb-0">
          {this.state.error.message}
        </pre>
      </div>
    );
  }
}
